<template>
  <div class="editor-emojis-window" style="display: none;">
    <div class="em-tabs">
      <button class="tab tab-emojis" title="Emojis" @click="$root.$emit('clear-gif-search')">
        Emojis
      </button>
      <button class="tab tab-gifs" title="Gifs">
        Gifs
      </button>
    </div>
    <div class="emojis-wrapper">
      <div class="emoji-tabs" />
      <div class="emojis" />
    </div>
    <TenorGifs />
  </div>
</template>

<script>
import TenorGifs from './TenorGifs';

export default {
  components: {
    TenorGifs,
  },
};
</script>
